

	<a *ngIf="item.type == 'page'" class="nav-link pl-0 pr-5" routerLink="/page/{{item.url}}" routerLinkActive="active">
		{{item.name | chooseTranslation}}
	</a>
	<span *ngIf="item.type == 'customLink' && encodedEmail" [innerHTML]="emailLink"></span>
	<a *ngIf="item.type == 'customLink' && !encodedEmail" class="nav-link pl-0 pr-5 d-block" href="{{item.url}}" target="{{item.target}}">{{item.name | chooseTranslation}}</a>

